module.exports = __webpack_public_path__ + "assets/images/hubs-logo-65e827d2d7c13ed734989200cdafc1ef.png";